import { Box, Typography, Button } from "@mui/material";
import { setRejectModalOpen } from "../../store/job/jobSlice";
import { useDispatch } from "react-redux";
const ProofHeader = ({
  proof_id,
  proof_data,
  proofLoading,
  onApprove,
  onReject,
  showAnnotated,
}) => {
  const allRejected = proof_data?.every(
    (item) => item.sent_approved_files === 3,
  );
  const allApproved = proof_data?.some(
    (item) => item.sent_approved_files === 2,
  );
  const dispatch = useDispatch();

  const isCommentsPresent = proof_data?.some(
    (item) => item.proof_comments && item.proof_comments.length > 0,
  );

  const handleApproveClick = () => {
    if (isCommentsPresent) {
      alert(
        'Please click on "Need Changes" as you have already added the comments.',
      );
    } else {
      onApprove();
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        mb: 0,
        minHeight: "60px",
        px: 1,
        pr: "20px",
      }}
    >
      {/* Logo on the left */}
      <Box sx={{ position: "absolute", left: 0 }}>
        <img
          src={proof_data?.[0]?.company_logo}
          alt="Company Logo"
          style={{ height: "40px", objectFit: "contain" }}
        />
      </Box>
      {!proofLoading && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, fontFamily: "'Inter Tight', sans-serif" }}
          >
            Proof Approval
          </Typography>
          {allApproved ? (
            <Typography variant="subtitle1" color="success.main">
              {proof_data?.find((item) => item.approved_proof)?.approved_proof
                ? `${
                    proof_data.find((item) => item.approved_proof)
                      .approved_proof
                  } Already Approved`
                : "Already Approved"}
            </Typography>
          ) : allRejected ? (
            <Typography variant="subtitle1" color="error.main">
              Already Rejected
            </Typography>
          ) : null}
        </Box>
      )}

      {/* Buttons on the right */}
      {!proofLoading && !allApproved && !allRejected && (
        <Box
          sx={{
            position: "absolute",
            right: "20px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{ mr: 1 }}
            onClick={handleApproveClick}
          >
            Approve
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => dispatch(setRejectModalOpen(true))}
          >
            {showAnnotated ? "Need Changes" : "Reject"}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ProofHeader;
